import KnowledgeBaseCourseManager from "./KnowledgeBaseCourseManager";

export default KnowledgeBaseCourseManager;
